import axios from "axios";
import { HOST_API_KEY } from "../../config";

export const getTrendingTerms = async (query = "") => {
  const response = await axios.get(`${HOST_API_KEY}/posts/trending`, {
    params: { query },
  });
  return response?.data;
};
